import React, { memo, MutableRefObject, useCallback } from 'react';

import Text from 'components/atoms/text';

import { TEXTS } from './config';
import sm from './styles.module.scss';

export type HandleDragOver = (e: React.DragEvent<HTMLDivElement>) => void;

interface Props {
  addFileHandler: HandleDragOver;
  isDisabled?: boolean;
  fileRef?: MutableRefObject<Nullable<HTMLInputElement>>;
}

type HandleDrop = (e: React.DragEvent<HTMLDivElement>) => void;

const DragAndDrop = ({ addFileHandler, isDisabled, fileRef }: Props) => {
  const handleDragOver: HandleDragOver = useCallback(
    (e) => e.preventDefault(),
    []
  );

  const handleDrop: HandleDrop = useCallback(
    (e) => {
      e.preventDefault();
      addFileHandler(e);
    },
    [addFileHandler]
  );

  return (
    <div
      className={sm.Button_Wrapper}
      onClick={() => fileRef?.current?.click()}
    >
      <div
        className={sm.Drag_drop_zone}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        role="button"
        tabIndex={0}
      >
        {isDisabled ? (
          <Text
            content={TEXTS.INPUT.DISABLED}
            with15Font
            isDisabled={isDisabled}
          />
        ) : (
          <>
            <Text content={TEXTS.INPUT.VALUE} with15Font />
            <div className={sm.LeftPadding}>
              <Text
                content={TEXTS.INPUT.VALUE_BROWSE}
                withBlueColor
                with15Font
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default memo(DragAndDrop);
